(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-timer"] && !Shopify.designMode) return;
  try {
    
    (function() {
      const sections = document.querySelectorAll('.countdown-timer-section');
      
      sections.forEach(function(section) {
        const endDate = section.dataset.endDate;
        const endTime = section.dataset.endTime;
        
        if (!endDate || !endTime) {
          return; // Already hidden by CSS
        }

        // Parse date and time
        // Expected format: YYYY-MM-DD for date, HH:MM for time
        const endDateTimeString = endDate + ' ' + endTime + ':00';
        const endDateTime = new Date(endDateTimeString);

        // Check if date is valid
        if (isNaN(endDateTime.getTime())) {
          console.warn('Countdown timer: Invalid date/time format. Expected: YYYY-MM-DD HH:MM');
          return; // Already hidden by CSS
        }

        // Check if timer has already expired
        const now = new Date();
        if (endDateTime <= now) {
          return; // Already hidden by CSS, don't show expired timers
        }

        // Timer is valid and in the future - show it
        section.setAttribute('data-visible', 'true');

        const display = section.querySelector('.countdown-timer__display');
        if (!display) return;

        const daysElement = display.querySelector('[data-days]');
        const hoursElement = display.querySelector('[data-hours]');
        const minutesElement = display.querySelector('[data-minutes]');
        const secondsElement = display.querySelector('[data-seconds]');

        // Declare interval variable in outer scope
        let interval;

        function updateCountdown() {
          const now = new Date();
          const difference = endDateTime - now;

          if (difference <= 0) {
            // Timer has ended, hide the section
            section.removeAttribute('data-visible'); // Remove visible attribute
            section.setAttribute('data-expired', 'true'); // Set expired attribute
            if (interval) {
              clearInterval(interval); // Stop the interval
            }
            return;
          }

          const days = Math.floor(difference / (1000 * 60 * 60 * 24));
          const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((difference % (1000 * 60)) / 1000);

          if (daysElement) daysElement.textContent = String(days).padStart(2, '0');
          if (hoursElement) hoursElement.textContent = String(hours).padStart(2, '0');
          if (minutesElement) minutesElement.textContent = String(minutes).padStart(2, '0');
          if (secondsElement) secondsElement.textContent = String(seconds).padStart(2, '0');
        }

        // Update immediately
        updateCountdown();

        // Update every second
        interval = setInterval(updateCountdown, 1000);

        // Clean up interval if section is removed
        const observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.removedNodes.length) {
              mutation.removedNodes.forEach(function(node) {
                if (node === section || (node.nodeType === 1 && node.contains(section))) {
                  clearInterval(interval);
                  observer.disconnect();
                }
              });
            }
          });
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      });
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
